// Module
var code = `<template>
  <mdc-dialog view-model.ref="dialog" class="two-field-prompt-dialog">
    <mdc-dialog-title if.bind="data.title">\${data.title}</mdc-dialog-title>
    <mdc-dialog-content style="width: 500px">
      <at-form-field>
        <mdc-text-field label.bind="data.label1" value.bind="data.text1 & validate" data-mdc-dialog-initial-focus>
        </mdc-text-field>
        <mdc-text-field-helper-line></mdc-text-field-helper-line>
      </at-form-field>
      <at-form-field style="margin-top: 12px; display:block;">
        <mdc-text-field label.bind="data.label2" value.bind="data.text2 & validate">
        </mdc-text-field>
        <mdc-text-field-helper-line></mdc-text-field-helper-line>
      </at-form-field>
    </mdc-dialog-content>
    <mdc-dialog-actions>
      <button mdc-button outlined data-mdc-dialog-action="cancel" if.bind="data.cancelText">\${data.cancelText}</button>
      <button mdc-button raised data-mdc-dialog-button-default click.delegate="ok()" if.bind="data.okText">\${data.okText}</button>
    </mdc-dialog-actions>
  </mdc-dialog>
</template>
`;
// Exports
export default code;